import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexDatapicker',
  setup(__props) {

const DefaultCalander = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/datepicker/DefaultCalander.vue"))
const BootstrapCalendar = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/datepicker/BootstrapCalendar.vue"))
const DatePicker = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/datepicker/DatePicker.vue"))
const TimePicker = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/datepicker/TimePicker.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DefaultCalander)),
      _createVNode(_unref(BootstrapCalendar)),
      _createVNode(_unref(DatePicker)),
      _createVNode(_unref(TimePicker))
    ])
  ]))
}
}

})